import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO, getBaseUrl } from '../../utils/seo';

const ServicesPage = () => {
  // SEO設定
  useSEO({
    title: '岡山市の解体工事・造園工事サービス｜おかやま解体工事株式会社',
    description: '岡山市で建物解体工事、内装解体工事、造園工事、外構エクステリア工事、不用品処理、原状回復工事を提供。創業30年以上の経験と実績で、お客様のニーズに応える6つの専門サービス。無料見積もり実施中。',
    keywords: '岡山市,解体工事,サービス,建物解体,内装解体,造園工事,外構工事,不用品処理,原状回復,岡山',
    canonicalPath: '/services',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: '解体工事・造園工事サービス',
      provider: {
        '@type': 'LocalBusiness',
        name: 'おかやま解体工事株式会社',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '北区○○町1-2-3',
          addressLocality: '岡山市',
          addressRegion: '岡山県',
          addressCountry: 'JP'
        },
        telephone: '+81-86-012-3456'
      },
      areaServed: {
        '@type': 'City',
        name: '岡山市'
      },
      description: '建物解体工事、内装解体工事、造園工事、外構エクステリア工事、不用品処理、原状回復工事などの総合建設サービス'
    }
  });

  const services = [
    {
      number: '01',
      title: '造園工事',
      subtitle: 'Landscaping',
      description: '庭のリニューアルから日常的な庭の片付けまで、幅広く対応しています。和風庭園から洋風ガーデンまで、お客様のご要望に合わせたデザインをご提案。植栽の選定から石組み、水回りの設置まで、トータルでサポートいたします。定期的なメンテナンスサービスもご用意しています。',
      image1: 'https://public.readdy.ai/ai/img_res/ac2b43bfda37b9c3f4d8dcedb346a642.jpg',
      image2: 'https://readdy.ai/api/search-image?query=wide%20view%20of%20Japanese%20garden%20renovation%20project%20showing%20before%20and%20during%20transformation%2C%20landscaping%20team%20planting%20trees%20and%20arranging%20natural%20elements%2C%20serene%20outdoor%20atmosphere%20with%20simple%20background&width=700&height=900&seq=service-detail3b&orientation=portrait',
    },
    {
      number: '02',
      title: '外構エクステリア工事',
      subtitle: 'Exterior Construction',
      description: '駐車場の舗装、フェンスや門扉の設置、ブロック塀の施工など、建物周りの外構工事全般を承ります。デザイン性と機能性を両立させた提案で、住まいの価値を高めます。耐久性の高い素材を使用し、長期間美しさを保てる施工を心がけています。',
      image1: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20installing%20modern%20exterior%20fencing%20and%20gate%20at%20residential%20property%2C%20professional%20exterior%20work%20with%20quality%20materials%2C%20clean%20simple%20background%20showing%20the%20installation%20process&width=500&height=600&seq=service-detail4a&orientation=portrait',
      image2: 'https://readdy.ai/api/search-image?query=wide%20view%20of%20Japanese%20team%20constructing%20parking%20area%20and%20exterior%20walls%2C%20professional%20exterior%20construction%20site%20with%20organized%20materials%20and%20equipment%2C%20bright%20outdoor%20setting%20with%20simple%20background&width=700&height=900&seq=service-detail4b&orientation=portrait',
    },
    {
      number: '03',
      title: '建物解体工事',
      subtitle: 'Building Demolition',
      description: '木造、鉄骨造、RC造など、あらゆる構造の建物解体に対応しています。創業30年以上の経験と最新の重機を駆使し、安全かつ迅速に作業を進めます。近隣への配慮を最優先に、騒音・粉塵対策を徹底。解体後の廃材は適切に分別処理し、環境にも配慮した施工を行います。',
      image1: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20using%20heavy%20machinery%20to%20demolish%20a%20concrete%20building%20in%20Okayama%2C%20professional%20demolition%20site%20with%20excavator%20and%20safety%20measures%2C%20bright%20daylight%20with%20simple%20clean%20background%2C%20organized%20industrial%20work%20environment&width=500&height=600&seq=service-detail1a&orientation=portrait',
      image2: 'https://readdy.ai/api/search-image?query=wide%20view%20of%20Japanese%20demolition%20team%20working%20on%20large%20building%20structure%20removal%2C%20multiple%20workers%20coordinating%20with%20heavy%20equipment%2C%20safety%20protocols%20visible%2C%20clean%20simple%20background%20highlighting%20the%20professional%20demolition%20process&width=700&height=900&seq=service-detail1b&orientation=portrait',
    },
    {
      number: '04',
      title: '内装解体工事',
      subtitle: 'Interior Demolition',
      description: '店舗やオフィスの原状回復工事を専門に行っています。スケルトン状態への解体から部分的な改修まで、お客様のニーズに合わせて柔軟に対応。短期間での施工が可能で、次の入居者様への引き渡しもスムーズです。産業廃棄物の適切な処理とマニフェストの発行も確実に行います。',
      image1: 'https://readdy.ai/api/search-image?query=Japanese%20workers%20carefully%20removing%20interior%20walls%20and%20fixtures%20in%20a%20commercial%20space%2C%20professional%20interior%20demolition%20work%20with%20precision%20tools%2C%20clean%20organized%20work%20site%20with%20simple%20background&width=500&height=600&seq=service-detail2a&orientation=portrait',
      image2: 'https://readdy.ai/api/search-image?query=detailed%20view%20of%20Japanese%20renovation%20team%20performing%20interior%20demolition%20in%20office%20space%2C%20removing%20ceiling%20and%20partition%20walls%20systematically%2C%20professional%20approach%20with%20safety%20equipment%2C%20simple%20clean%20background&width=700&height=900&seq=service-detail2b&orientation=portrait',
    },
    {
      number: '05',
      title: 'ゴミ・不用品処理',
      subtitle: 'Waste Disposal',
      description: 'ゴミ屋敷の片付けから生前整理、遺品整理まで、丁寧に対応いたします。大量の不用品も迅速に処理し、必要に応じて買取サービスもご利用いただけます。プライバシーに配慮した作業で、ご近所の目も気になりません。処分困難物の相談も承ります。',
      image1: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d95fd417a9cb5256e145cd375f27cbf2.jpeg',
      image2: 'https://readdy.ai/api/search-image?query=wide%20view%20of%20Japanese%20team%20efficiently%20clearing%20out%20unwanted%20items%20from%20property%2C%20professional%20waste%20removal%20service%20with%20truck%20and%20organized%20sorting%20system%2C%20clean%20simple%20background&width=700&height=900&seq=service-detail5b&orientation=portrait',
    },
    {
      number: '06',
      title: '原状回復工事',
      subtitle: 'Property Restoration',
      description: '賃貸物件の退去時における原状回復工事を専門に行っています。壁紙の張替え、床の補修、設備の修繕など、入居時の状態に戻すための作業を総合的にサポート。オーナー様と入居者様の双方が納得できる仕上がりを目指し、トラブルのない退去をお手伝いします。',
      image1: 'https://readdy.ai/api/search-image?query=Japanese%20renovation%20workers%20repairing%20and%20restoring%20rental%20property%20interior%2C%20professional%20restoration%20work%20on%20walls%20and%20floors%2C%20clean%20organized%20work%20environment%20with%20simple%20background&width=500&height=600&seq=service-detail6a&orientation=portrait',
      image2: 'https://readdy.ai/api/search-image?query=wide%20view%20of%20Japanese%20team%20performing%20complete%20property%20restoration%20including%20painting%20and%20floor%20repair%2C%20professional%20property%20maintenance%20service%2C%20bright%20indoor%20setting%20with%20simple%20background&width=700&height=900&seq=service-detail6b&orientation=portrait',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[300px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/9a19d824fd1ea97bbb3da7da8c6ddcb4.jpeg"
            alt="事業案内"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center">
          <div className="inline-flex items-center space-x-4 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
            <i className="ri-tools-line text-white w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm font-medium text-white">幅広いサービス</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            事業案内
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
            お客様のニーズに合わせた幅広いサービスを提供しています
          </p>
        </div>
      </section>

      {/* Services Detail Sections */}
      {services.map((service, index) => (
        <section
          key={index}
          className={`py-16 lg:py-24 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          <div className="container mx-auto px-4 lg:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              {/* Text Content */}
              <div className={`lg:col-span-5 ${index % 2 === 1 ? 'lg:col-start-8' : ''}`}>
                <div className="inline-block border border-gray-300 px-4 py-1 rounded-full text-xs text-gray-600 mb-4">
                  SERVICE {service.number}
                </div>
                <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-2 pb-4 border-b-2 border-primary">
                  {service.title}
                </h2>
                <p className="text-xl text-gray-500 mb-12">{service.subtitle}</p>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {service.description}
                </p>
              </div>

              {/* Images */}
              <div className={`lg:col-span-7 ${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                <div className="grid grid-cols-2 gap-4">
                  <div className="w-full h-80 lg:h-96 rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={service.image1}
                      alt={`${service.title} 1`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="w-full h-80 lg:h-96 rounded-2xl overflow-hidden shadow-xl">
                    <img
                      src={service.image2}
                      alt={`${service.title} 2`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20panoramic%20view%20of%20beautiful%20Okayama%20cityscape%20with%20construction%20site%20in%20foreground%2C%20professional%20Japanese%20workers%20visible%20in%20distance%2C%20bright%20sunny%20day%20with%20clear%20sky%2C%20clean%20organized%20work%20environment%2C%20inspiring%20and%20professional%20atmosphere&width=1920&height=1080&seq=services-cta&orientation=landscape"
            alt="岡山の風景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
              まずはお気軽に<br />ご相談ください
            </h2>
          </div>
          <div className="absolute bottom-12 right-8 text-right">
            <p className="text-white text-xl lg:text-2xl font-light mb-4">
              無料見積もり・現地調査実施中
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-end">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-primary rounded-full hover:bg-gray-100 transition-all font-medium whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center px-8 py-4 bg-secondary text-white rounded-full hover:bg-primary transition-all font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                086-012-3456
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
